import React, { useCallback } from 'react';
import Icon from '../../../../Icon/Icon';
import { useDropzone } from 'react-dropzone';
import { isValidFile } from '../../../../../utils/functions.js';

function UploadZone({
    title,
    text,
    onDropFiles,
    filesIgnored,
    canUpload,
    disabledMessage,
    onAddDynamicUrl,
    addDynamicUrlLabel = 'Dynamic URL',
}) {
    const onDrop = useCallback(
        (acceptedFiles) => {
            if (!canUpload) return;

            const acceptedFilesFiltered = acceptedFiles.filter((file) =>
                isValidFile(file, [
                    'jpg',
                    'jpeg',
                    'png',
                    'gif',
                    'mp4',
                    'zip',
                ])
            );
            onDropFiles(acceptedFilesFiltered);
        },
        [canUpload, onDropFiles]
    );

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'image/jpeg': ['.jpeg', '.jpg'],
            'image/png': ['.png'],
            'image/gif': ['.gif'],
            'video/mp4': ['.mp4'],
            'application/zip': ['.zip'],
        },
        disabled: !canUpload,
    });

    return canUpload ? (
        <div>
            <div
                {...getRootProps()}
                className={`border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-blue-400 transition-colors py-10
            ${isDragActive ? 'border-blue-400' : ''}
            ${filesIgnored > 0 ? 'bg-yellow-100 text-yellow-800' : ''}
            `}>
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p>Drop the files here ...</p>
                ) : (
                    <p>
                        Drag 'n' drop some files here, or click to select files
                    </p>
                )}
                {filesIgnored > 0 && (
                    <div
                        className={`w-full h-full flex flex-row items-center align-center justify-center`}>
                        <Icon
                            name="exclamation-triangle"
                            className="mr-2"
                        />
                        <p className="bg-yellow-100 text-yellow-800">
                            <b>{filesIgnored}</b> archivos no se cargaron porque
                            están duplicados o no coinciden con las
                            características de ningún grupo de pantallas.
                        </p>
                    </div>
                )}
            </div>
            <div className="mt-4 text-left">
                <h4>Supported file types:</h4>
                <ul className="list-disc list-inside text-left mt-2 text-sm text-gray-600">
                    <li>
                        <b>Images</b>: JPG, JPEG, PNG, GIF
                    </li>
                    <li>
                        <b>Videos</b>: MP4
                    </li>
                    <li>
                        <b>Dynamic Ads</b>: ZIP files containing multiple
                        creatives
                        {onAddDynamicUrl && (
                            <>
                                {' or '}
                                <button
                                    type="button"
                                    onClick={onAddDynamicUrl}
                                    className="inline-flex items-center font-medium text-blue-600 underline hover:text-blue-800 focus:outline-none"
                                    data-testid="UploadZone-dynamicUrl">
                                    <Icon name="link" className="mr-1" />
                                    {addDynamicUrlLabel}
                                </button>
                            </>
                        )}
                    </li>
                </ul>
            </div>
        </div>
    ) : (
        <div
            className={`border-2 border-dashed border-red-500 rounded-lg p-6 text-center transition-colors py-10 bg-yellow-100`}>
            <p className="bg-yellow-100 text-yellow-800">
                {disabledMessage ||
                    'Guarda la campaña para habilitar la zona de carga de archivos.'}
            </p>
        </div>
    );
}

export default UploadZone;
